import React, { memo, useRef, useState } from 'react'
import { dottedImg, left_arrow, no_image } from '../../assets/imgs'
import ReactPlayer from 'react-player'
import CancelIcon from '@mui/icons-material/Cancel';
import { toast } from 'react-toastify';
import { usePropertyDocumentAddMutation } from '../redux/api/api';
import { useNavigate } from 'react-router-dom';

const AddDocument = ({ propertyId, setTabs, setDetails }) => {
    const [documentData, setDocumentData] = useState({
        aadhar_img: [],
        gst_img: [],
        gst_number: '',
        bs_certificate_img: [],
        account_no: '',
        ifsc_code: '',
        branch_code: '',
        branch_name: '',
        property_video: null,
        selfie_image: null
    });
    const [imageToShow, setImageToShow] = useState(null);

    // RTK Mutation for adding documents
    const [documentAddApi] = usePropertyDocumentAddMutation();
    const [loading, setLoading] = useState(false);

    // Refs for file inputs
    const aadharInputRef = useRef(null);
    const gstInputRef = useRef(null);
    const bsCertInputRef = useRef(null);
    const selfieInputRef = useRef(null);
    const videoInputRef = useRef(null);

    // Store original file objects along with preview URLs
    const [fileObjects, setFileObjects] = useState({
        aadhar_img: [],
        gst_img: [],
        bs_certificate_img: [],
        selfie_image: null,
        property_video: null
    });

    const handleAddDocuments = async () => {

        if (documentData.aadhar_img.length > 2) {
            toast.error("Maximum Two Aadhar Image can be uploaded");
            return;
        }

        if (!documentData.bs_certificate_img || documentData.bs_certificate_img.length === 0) {
            toast.error("Business Certificate Image is required");
            return;
        }

        // if (!documentData.property_video) {
        //     toast.error("Property Video is required");
        //     return;
        // }

        // if (!documentData.selfie_image) {
        //     toast.error("Selfie Image is required");
        //     return;
        // }

        setLoading(true);
        const formdata = new FormData();


        formdata.append('property_id', propertyId);
        formdata.append('gst_number', documentData.gst_number || '');
        formdata.append('account_no', documentData.account_no || '');
        formdata.append('ifsc_code', documentData.ifsc_code || '');
        formdata.append('branch_code', documentData.branch_code || '');
        formdata.append('branch_name', documentData.branch_name || '');


        if (fileObjects.selfie_image) {
            formdata.append('selfie_image', fileObjects.selfie_image);
        }


        if (fileObjects.property_video) {
            formdata.append('property_video', fileObjects.property_video);
        }


        fileObjects.aadhar_img.forEach((file, index) => {
            formdata.append(`aadhar_img[${index}]`, file);
        });


        fileObjects.gst_img.forEach((file, index) => {
            formdata.append(`gst_img[${index}]`, file);
        });


        fileObjects.bs_certificate_img.forEach((file, index) => {
            formdata.append(`bs_certificate_img[${index}]`, file);
        });


        for (let [key, value] of formdata.entries()) {
            console.log(`${key}:`, value);
        }

        documentAddApi(formdata)
            .unwrap()
            .then((res) => {
                if (res?.status === 'success') {
                    toast.success(res?.message);
                    setDetails((prev) => ({
                        ...prev,
                        document_status: 2
                    }))
                    setTabs(7)
                }
            })
            .catch((err) => {
                console.error('Error adding documents:', err);
                toast.error(err?.message || "Failed to add documents");
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleImageUpload = (e, field) => {
        const files = Array.from(e.target.files);

        if (field === 'selfie_image' && files.length > 1) {
            toast.error("You can upload only one selfie image");
            return;
        }

        if (files.length > 5 && field !== 'selfie_image') {
            toast.error("You can upload maximum 5 images");
            return;
        }

        const imageFiles = files.filter(file => file.type.startsWith('image/'));
        if (imageFiles.length !== files.length) {
            toast.error("Only image files are allowed");
            return;
        }


        const newImages = imageFiles.map(file => URL.createObjectURL(file));


        setFileObjects(prev => {
            if (field === 'selfie_image') {
                return {
                    ...prev,
                    [field]: imageFiles[0] || null
                };
            }

            const existingFiles = prev[field] || [];
            return {
                ...prev,
                [field]: [...existingFiles, ...imageFiles]
            };
        });

        // Update preview URLs in documentData
        setDocumentData(prev => {
            if (field === 'selfie_image') {
                return {
                    ...prev,
                    [field]: newImages[0] || ''
                };
            }

            const existingImages = prev[field] || [];
            return {
                ...prev,
                [field]: [...existingImages, ...newImages]
            };
        });
    };

    const handleVideoUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (!file.type.startsWith('video/')) {
            toast.error("Only video files are allowed");
            return;
        }

        const videoUrl = URL.createObjectURL(file);


        setFileObjects(prev => ({
            ...prev,
            property_video: file
        }));


        setDocumentData(prev => ({
            ...prev,
            property_video: videoUrl
        }));
    };

    const removeImage = (field, index) => {
        setDocumentData(prev => {
            if (field === 'selfie_image') {
                return { ...prev, [field]: '' };
            }
            const updatedImages = [...prev[field]];
            updatedImages.splice(index, 1);
            return { ...prev, [field]: updatedImages };
        });

        setFileObjects(prev => {
            if (field === 'selfie_image') {
                return { ...prev, [field]: null };
            }
            const updatedFiles = [...prev[field]];
            updatedFiles.splice(index, 1);
            return { ...prev, [field]: updatedFiles };
        });
    };

    const handleFieldChange = (field, value) => {
        setDocumentData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const openImagePopup = (imgUrl) => {
        setImageToShow(imgUrl);
    };

    const navigate = useNavigate();

    return (
        <div className="mt-2">
            <div className="d-flex ac-js">
                <div className="d-flex ac-jb w-100">
                    <div className="d-flex ac-js pointer gap-2">
                        <img
                            src={left_arrow}
                            className="leftArrow mb-3 pointer"
                            onClick={() => navigate(-1)}
                            alt="Back"
                        />
                        <p
                            className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary pointer"
                            onClick={() => navigate(-1)}
                        >
                            Back
                        </p>
                    </div>

                </div>
            </div>

            {/* Aadhar Card Section */}
            <div className="d-flex gap-5 mb-2 align-items-center">
                <div className="col-md-5">
                    <div className='d-flex ac-jb'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Business Registration Certificate *
                        </h4>
                        <input
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            ref={bsCertInputRef}
                            onChange={(e) => handleImageUpload(e, 'bs_certificate_img')}
                            multiple
                        />
                    </div>
                    <button
                        onClick={() => bsCertInputRef.current.click()}
                        className="f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-11 fs-xxl-12 w-20 cust-btn recep-yes my-2"
                    >
                        Upload
                    </button>
                    <div className='d-flex ac-js gap-3 flex-wrap'>
                        {documentData.bs_certificate_img.length > 0 ? (
                            documentData.bs_certificate_img.map((img, index) => (
                                <div key={index} className="position-relative">
                                    <img
                                        src={img}
                                        className='small-imgs'
                                        alt={`Certificate ${index + 1}`}
                                        onClick={() => openImagePopup(img)}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <CancelIcon
                                        className="red pointer"
                                        style={{
                                            position: "absolute",
                                            top: "-7px",
                                            right: "-7px",
                                            width: "15px",
                                        }}
                                        onClick={() => removeImage('bs_certificate_img', index)}
                                    />
                                </div>
                            ))
                        ) : (
                            <img src={no_image} className='small-imgs' alt="No Certificate" />
                        )}
                    </div>
                </div>

                <div className="col-md-5">
                    <div className='d-flex ac-jb'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Aadhar Card
                        </h4>
                        <input
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            ref={aadharInputRef}
                            onChange={(e) => handleImageUpload(e, 'aadhar_img')}
                            multiple
                        />
                    </div>
                    <div className='d-flex ac-js gap-2'>
                        <button
                            onClick={() => aadharInputRef.current.click()}
                            className="f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-11 fs-xxl-12 w-20 cust-btn recep-yes my-2"
                        >
                            Upload
                        </button>
                        <p className='fw-700 mt-2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-11 fs-xxl-12 text-danger'>
                            * Maximum two images
                        </p>
                    </div>
                    <div className='d-flex ac-js gap-3 flex-wrap'>
                        {documentData.aadhar_img.length > 0 ? (
                            documentData.aadhar_img.map((img, index) => (
                                <div key={index} className="position-relative">
                                    <img
                                        src={img}
                                        className='small-imgs'
                                        alt={`Aadhar ${index + 1}`}
                                        onClick={() => openImagePopup(img)}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <CancelIcon
                                        className="red pointer"
                                        style={{
                                            position: "absolute",
                                            top: "-7px",
                                            right: "-7px",
                                            width: "15px",
                                        }}
                                        onClick={() => removeImage('aadhar_img', index)}
                                    />
                                </div>
                            ))
                        ) : (
                            <img src={no_image} className='small-imgs' alt="No Aadhar" />
                        )}
                    </div>
                </div>
            </div>

            {/* GST Number and Business Certificate Section */}
            <div className="d-flex gap-5 mb-2 align-items-center">
                <div className="col-md-5 mt-3">
                    <div className='d-flex ac-jb'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            GST
                        </h4>
                        <input
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            ref={gstInputRef}
                            onChange={(e) => handleImageUpload(e, 'gst_img')}
                            multiple
                        />
                    </div>
                    <button
                        onClick={() => gstInputRef.current.click()}
                        className="f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-11 fs-xxl-12 w-20 cust-btn recep-yes my-2"
                    >
                        Upload
                    </button>
                    <div className='d-flex ac-js gap-3 flex-wrap'>
                        {documentData.gst_img.length > 0 ? (
                            documentData.gst_img.map((img, index) => (
                                <div key={index} className="position-relative">
                                    <img
                                        src={img}
                                        className='small-imgs'
                                        alt={`GST ${index + 1}`}
                                        onClick={() => openImagePopup(img)}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <CancelIcon
                                        className="red pointer"
                                        style={{
                                            position: "absolute",
                                            top: "-7px",
                                            right: "-7px",
                                            width: "15px",
                                        }}
                                        onClick={() => removeImage('gst_img', index)}
                                    />
                                </div>
                            ))
                        ) : (
                            <img src={no_image} className='small-imgs' alt="No GST" />
                        )}
                    </div>
                </div>
                <div className="col-md-5">
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        GST Number (if Registered)
                    </h4>
                    <input
                        type="text"
                        className="input-pop ps-2 w-100"
                        placeholder="GST Number"
                        value={documentData.gst_number}
                        onChange={(e) => handleFieldChange('gst_number', e.target.value)}
                    />
                </div>
            </div>

            <hr className="border-2 primary mt-3" />

            {/* Bank Details Section */}
            <h4 className="f2 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mt-3">
                Bank Details
            </h4>
            <div className="d-flex gap-5 mb-4 align-items-center">
                <div className="col-md-5">
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        Account Number
                    </h4>
                    <input
                        type="text"
                        className="input-pop ps-2 w-100"
                        placeholder="Enter Account Number"
                        value={documentData.account_no}
                        onChange={(e) => handleFieldChange('account_no', e.target.value)}
                    />
                </div>
                <div className="col-md-5">
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        IFSC Code
                    </h4>
                    <input
                        type="text"
                        className="input-pop ps-2 w-100"
                        placeholder="Enter IFSC Code"
                        value={documentData.ifsc_code}
                        onChange={(e) => handleFieldChange('ifsc_code', e.target.value)}
                    />
                </div>
            </div>
            <div className="d-flex gap-5 mb-4 align-items-center">
                <div className="col-md-5">
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        Branch Code
                    </h4>
                    <input
                        type="text"
                        className="input-pop ps-2 w-100"
                        placeholder="Enter Branch Code"
                        value={documentData.branch_code}
                        onChange={(e) => handleFieldChange('branch_code', e.target.value)}
                    />
                </div>
                <div className="col-md-5">
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                        Bank Name
                    </h4>
                    <input
                        type="text"
                        className="input-pop ps-2 w-100"
                        placeholder="Enter Bank Name"
                        value={documentData.branch_name}
                        onChange={(e) => handleFieldChange('branch_name', e.target.value)}
                    />
                </div>
            </div>

            <hr className="border-2 primary mt-3" />

            <div className="d-flex col-md-12 ac-jc my-2 mb-5">
                <div className="col-md-5">
                    <div className='d-flex ac-jb mx-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Video Verification
                        </h4>
                        <input
                            type="file"
                            accept="video/*"
                            style={{ display: 'none' }}
                            ref={videoInputRef}
                            onChange={handleVideoUpload}
                        />
                        <button
                            onClick={() => videoInputRef.current.click()}
                            className="f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-11 fs-xxl-12 w-20 cust-btn recep-yes"
                        >
                            Upload
                        </button>
                    </div>
                    <div className='video-player'>
                        {documentData.property_video ? (
                            <ReactPlayer
                                width="100%"
                                height="100%"
                                controls={true}
                                url={documentData.property_video}
                            />
                        ) : (
                            <div className="d-flex ac-jc" style={{ height: '100%' }}>
                                <img src={dottedImg} className='video-player' alt="No Video" style={{ height: '230px', width: '400px' }} />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className='d-flex col-md-12 ac-jc my-2'>
                <div className="col-md-5">
                    <div className='d-flex ac-jb mx-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Image Verification
                        </h4>
                        <input
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            ref={selfieInputRef}
                            onChange={(e) => handleImageUpload(e, 'selfie_image')}
                        />
                        <button
                            onClick={() => selfieInputRef.current.click()}
                            className="f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-11 fs-xxl-12 w-20 cust-btn recep-yes"
                        >
                            {documentData.selfie_image ? 'ReUpload' : 'Upload'}
                        </button>
                    </div>
                    {documentData.selfie_image ? (
                        <div className="position-relative">
                            <img
                                src={documentData.selfie_image}
                                className='video-player'
                                alt="Selfie"
                                onClick={() => openImagePopup(documentData.selfie_image)}
                                style={{ cursor: 'pointer', height: '230px', width: '400px', objectFit: 'cover' }}
                            />
                            <CancelIcon
                                className="red pointer"
                                style={{
                                    position: "absolute",
                                    top: "-7px",
                                    right: "-7px",
                                    width: "15px",
                                }}
                                onClick={() => removeImage('selfie_image', 0)}
                            />
                        </div>
                    ) : (
                        <div className="d-flex ac-jc" style={{ height: '100%' }}>
                            <img src={dottedImg} className='video-player' alt="No Selfie" style={{ height: '230px', width: '400px' }} />
                        </div>
                    )}
                </div>
            </div>

            {/* Image Preview Popup */}
            {imageToShow && (
                <div className="img-popup-design-new">
                    <div className="img-popup-new" style={{ maxWidth: '90%', maxHeight: '90%' }}>
                        <div className='d-flex ac-je'>
                            <button
                                className='cust-btn'
                                onClick={() => setImageToShow(null)}
                            >
                                <CancelIcon />
                            </button>
                        </div>
                        <div className="d-flex ac-jc" style={{ height: '100%' }}>
                            <img
                                src={imageToShow}
                                style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                alt="Preview"
                            />
                        </div>
                    </div>
                </div>
            )}

            {/* Submit Button */}
            <div className="d-flex ac-je mt-5">
                <button
                    className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
                    onClick={handleAddDocuments}
                    disabled={loading}
                >
                    {loading ? (
                        <div className="spinner-border spinner-border-sm"></div>
                    ) : (
                        "Next"
                    )}
                </button>
            </div>
        </div>
    )
};

export default memo(AddDocument);